import Reflux from 'reflux'
import ResizeActions from '../actions/ResizeActions'

/*var ResizeStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(ResizeActions.splitterResize,'onSplitterResize');
		this.listenTo(ResizeActions.dividedBoxDidMount,'onDividedBoxDidMount');
	},
    onSplitterResize(_id,_value,addon)
    {
        //this.values.push(_value);
		this.trigger(_id,_value,addon);
    },
    onDividedBoxDidMount(_id,_value,addon)
    {
    	this.trigger(_id,_value,addon);
    }
});*/
export var VerticalSplitterStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.verticalSplitterResize,'onVerticalSplitterResize');
    },
    onVerticalSplitterResize(_id,addon)
    {
        this.trigger(_id,addon);
    }
});

export var GetSubFieldGroupMaxWidthStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.getSubFieldGroupMaxWidth,'onGetSubFieldGroupMaxWidthStore');
    },
    onGetSubFieldGroupMaxWidthStore(_id,maxWidths)
    {
        this.trigger(_id,maxWidths);
    }

});

export var SetSubFieldGroupMaxWidthStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.setSubFieldGroupMaxWidth,'onSetSubFieldGroupMaxWidthStore');
    },
    onSetSubFieldGroupMaxWidthStore(_id,maxWidth)
    {
        this.trigger(_id,maxWidth);
    }

});

export var VisibleFalseToTrueStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.visibleFalseToTrue,'onVisibleFalseToTrue');
    },
    onVisibleFalseToTrue()
    {
        this.trigger();
    }
});

export var GroupSlideStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.groupSlide,'onGroupSlideStore');
    },
    onGroupSlideStore(arg)
    {
        this.trigger(arg);
    }
});

export var GroupRefersheStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(ResizeActions.groupRefersh,'onGroupRefersheStore');
    },
    onGroupRefersheStore(arg)
    {
        this.trigger(arg);
    }
});


// WEBPACK FOOTER //
// ./src/stores/ResizeStore.js